export enum AlertToastType {
  CAMERA_PANIC = 'CAMERA_PANIC',
  PERSON_DETECTION = 'PERSON_DETECTION',
  PLATE = 'PLATE',
  OBJECT_DETECTION = 'OBJECT_DETECTION',
  GENERIC = 'GENERIC',
  PERSONAL_PANIC = 'PERSONAL_PANIC',
  CAMERA_DOWNLOAD = 'CAMERA_DOWNLOAD',
  CAMERA_TIMELAPSE = 'CAMERA_TIMELAPSE',
  CAMERA_MOVEMENT = 'CAMERA_MOVEMENT',
  CAMERA_MOVEMENT_PORTAL = 'CAMERA_MOVEMENT_PORTAL',
  PERSON_DETECTION_v2 = 'PERSON_DETECTION_v2',
  AGGLOMERATION_DETECTION = 'AGGLOMERATION_DETECTION',
  FALL_DETECTION = 'FALL_DETECTION',
  VEHICLE_MODEL = 'VEHICLE_MODEL',
  CAMERA_STATUS = 'CAMERA_STATUS',
  panicAlert = 'panicAlert',
  motionAlert = 'motionAlert',
  FACIAL = 'FACIAL',
  FACIAL_EMBEDDED = 'FACIAL_EMBEDDED',
  FACIAL_IN_GROUP = 'FACIAL_IN_GROUP',
  FACIAL_IN_GROUP_EMBEDDED = 'FACIAL_IN_GROUP_EMBEDDED',
  FACIAL_CAMERA_GROUP = 'FACIAL_CAMERA_GROUP',
  FACIAL_CAMERA_GROUP_EMBEDDED = 'FACIAL_CAMERA_GROUP_EMBEDDED',
  FACIAL_UNIDENTIFIED = 'FACIAL_UNIDENTIFIED',
  FACIAL_UNIDENTIFIED_EMBEDDED = 'FACIAL_UNIDENTIFIED_EMBEDDED',
  ADVANCED_SEARCH_FINISHED = 'ADVANCED_SEARCH_FINISHED',
}
export const FACIAL_BASE_TYPES = ['FACIAL', 'FACIAL_EMBEDDED'] as const;

export const FACIAL_IN_GROUP_TYPES = [
  'FACIAL_IN_GROUP',
  'FACIAL_IN_GROUP_EMBEDDED',
] as const;

export const FACIAL_CAMERA_GROUP_TYPES = [
  'FACIAL_CAMERA_GROUP',
  'FACIAL_CAMERA_GROUP_EMBEDDED',
] as const;

export const FACIAL_UNIDENTIFIED_TYPES = [
  'FACIAL_UNIDENTIFIED',
  'FACIAL_UNIDENTIFIED_EMBEDDED',
] as const;

// Todos os tipos faciais agrupados
export const ALL_FACIAL_TYPES = [
  ...FACIAL_BASE_TYPES,
  ...FACIAL_IN_GROUP_TYPES,
  ...FACIAL_CAMERA_GROUP_TYPES,
  ...FACIAL_UNIDENTIFIED_TYPES,
] as const;
export interface AlertToastConfig {
  title: string;
  subTitle: string;
  confirmButton: string;
  icon: string;
}

export interface ToastData {
  type: AlertToastType;
  showImage: boolean;
  imageUrl: string;
  icon: string;
  titleHeader: string;
  title: string;
  subtitle: string;
  quantityBorderBox: number;
  formattedDate: string;
  buttonLabel: string;
  buttonBgColor: string;
  buttonFontColor: string;
  isPrimaryButton: boolean;
  personName?: string;
  plate?: string;
  plateDescription?: string;
  hasRestriction?: boolean;
  reliability?: number;
  groups?: number | string;
  cameraTitle?: string;
  cameraId?: string;
  cameraAddress?: string;
  isCameraOnlineOnNotify?: boolean;
  userName?: string;
  message_camera?: string;
  modelDescription?: string;
  model?: string;
  groupName?: string;
  groupId?: string;
  infoMessage?: string;
}

// ─── Grupos de tipos por comportamento ───────────────────────────────────────

export const MOVEMENT_TYPES = [
  AlertToastType.CAMERA_MOVEMENT,
  AlertToastType.CAMERA_MOVEMENT_PORTAL,
  AlertToastType.AGGLOMERATION_DETECTION,
  AlertToastType.FALL_DETECTION,
  AlertToastType.PERSON_DETECTION_v2,
] as const;

export type MovementType = (typeof MOVEMENT_TYPES)[number];

export const CAMERA_VIEW_TYPES = [
  AlertToastType.CAMERA_PANIC,
  AlertToastType.PERSON_DETECTION,
  AlertToastType.OBJECT_DETECTION,
  AlertToastType.GENERIC,
  AlertToastType.CAMERA_STATUS,
  AlertToastType.motionAlert,
  AlertToastType.PLATE,
  AlertToastType.VEHICLE_MODEL,
  AlertToastType.AGGLOMERATION_DETECTION,
  AlertToastType.FALL_DETECTION,
  AlertToastType.ADVANCED_SEARCH_FINISHED,
] as const;

export type CameraViewType = (typeof CAMERA_VIEW_TYPES)[number];

export const IMAGE_TOAST_TYPES = [
  AlertToastType.CAMERA_MOVEMENT,
  AlertToastType.CAMERA_MOVEMENT_PORTAL,
  AlertToastType.PERSON_DETECTION_v2,
  AlertToastType.CAMERA_PANIC,
  AlertToastType.PLATE,
  AlertToastType.CAMERA_STATUS,
  AlertToastType.PERSONAL_PANIC,
  AlertToastType.AGGLOMERATION_DETECTION,
  AlertToastType.VEHICLE_MODEL,
  AlertToastType.FALL_DETECTION,
  AlertToastType.ADVANCED_SEARCH_FINISHED,
] as const;

export type ImageToastType = (typeof IMAGE_TOAST_TYPES)[number];

// ─── Mapas de configuração ────────────────────────────────────────────────────

export const NOTIFICATION_CONFIG_MAP: Partial<Record<AlertToastType, string>> =
  {
    [AlertToastType.CAMERA_MOVEMENT]: 'pushMovement',
    [AlertToastType.CAMERA_MOVEMENT_PORTAL]: 'pushMovement',
    [AlertToastType.PERSON_DETECTION_v2]: 'pushPersonDetection',
    [AlertToastType.CAMERA_PANIC]: 'pushPanic',
    [AlertToastType.CAMERA_STATUS]: 'pushStatus',
    [AlertToastType.PLATE]: 'pushBlacklist',
    [AlertToastType.FACIAL]: 'pushFacial',
    [AlertToastType.FACIAL_EMBEDDED]: 'pushFacial',
    [AlertToastType.FACIAL_IN_GROUP]: 'pushFacial',
    [AlertToastType.FACIAL_IN_GROUP_EMBEDDED]: 'pushFacial',
    [AlertToastType.FACIAL_CAMERA_GROUP]: 'pushFacial',
    [AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED]: 'pushFacial',
    [AlertToastType.FACIAL_UNIDENTIFIED]: 'pushFacial',
    [AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED]: 'pushFacial',
    [AlertToastType.AGGLOMERATION_DETECTION]: 'pushAgglomeration',
    [AlertToastType.FALL_DETECTION]: 'pushFallDetection',
    [AlertToastType.VEHICLE_MODEL]: 'pushBlacklistModel',
    [AlertToastType.PERSONAL_PANIC]: 'pushPersonalPanic',
  };

export const ICON_MAP: Partial<Record<AlertToastType, string>> = {
  [AlertToastType.CAMERA_PANIC]: 'pi pi-exclamation-triangle',
  [AlertToastType.PLATE]: 'pi pi-car',
  [AlertToastType.VEHICLE_MODEL]: 'pi pi-car',
  [AlertToastType.PERSON_DETECTION]: 'pi pi-users',
  [AlertToastType.OBJECT_DETECTION]: 'pi pi-users',
  [AlertToastType.GENERIC]: 'pi pi-clock',
  [AlertToastType.PERSONAL_PANIC]: 'pi pi-exclamation-circle',
  [AlertToastType.CAMERA_DOWNLOAD]: 'pi pi-download',
  [AlertToastType.CAMERA_TIMELAPSE]: 'pi pi-file-edit',
  [AlertToastType.CAMERA_MOVEMENT]: 'pi pi-user',
  [AlertToastType.CAMERA_MOVEMENT_PORTAL]: 'pi pi-user',
  [AlertToastType.PERSON_DETECTION_v2]: 'pi pi-user',
  [AlertToastType.AGGLOMERATION_DETECTION]: 'pi pi-user',
  [AlertToastType.FALL_DETECTION]: 'pi pi-user',
  [AlertToastType.ADVANCED_SEARCH_FINISHED]: 'pi pi-user',
};

export const BUTTON_LABEL_MAP: Partial<Record<AlertToastType, string>> = {
  [AlertToastType.CAMERA_PANIC]: 'Ver câmera',
  [AlertToastType.PERSON_DETECTION]: 'Ver câmera',
  [AlertToastType.OBJECT_DETECTION]: 'Ver câmera',
  [AlertToastType.GENERIC]: 'Ver câmera',
  [AlertToastType.CAMERA_MOVEMENT]: 'Ver câmera',
  [AlertToastType.CAMERA_MOVEMENT_PORTAL]: 'Ver câmera',
  [AlertToastType.PERSON_DETECTION_v2]: 'Ver câmera',
  [AlertToastType.CAMERA_STATUS]: 'Ver câmera',
  [AlertToastType.motionAlert]: 'Ver câmera',
  [AlertToastType.PLATE]: 'Ver câmera',
  [AlertToastType.VEHICLE_MODEL]: 'Ver câmera',
  [AlertToastType.CAMERA_DOWNLOAD]: 'Acessar',
  [AlertToastType.CAMERA_TIMELAPSE]: 'Acessar',
  [AlertToastType.panicAlert]: 'Ir para endereço',
  [AlertToastType.FACIAL]: 'Ver reconhecimento',
  [AlertToastType.FACIAL_EMBEDDED]: 'Ver reconhecimento',
  [AlertToastType.FACIAL_IN_GROUP]: 'Ver reconhecimento',
  [AlertToastType.FACIAL_IN_GROUP_EMBEDDED]: 'Ver reconhecimento',
  [AlertToastType.FACIAL_CAMERA_GROUP]: 'Ver reconhecimento',
  [AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED]: 'Ver reconhecimento',
  [AlertToastType.FACIAL_UNIDENTIFIED]: 'Reassociar',
  [AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED]: 'Reassociar',
  [AlertToastType.AGGLOMERATION_DETECTION]: 'Ver câmera',
  [AlertToastType.FALL_DETECTION]: 'Ver câmera',
  [AlertToastType.PERSONAL_PANIC]: 'Ir para endereço',
  [AlertToastType.ADVANCED_SEARCH_FINISHED]: 'Ver Busca Avançada',
};

export const TOAST_ICON_MAP: Partial<Record<AlertToastType, string>> = {
  [AlertToastType.CAMERA_MOVEMENT]:
    'assets/images/icons/svg/motion-detection-disabled.svg',
  [AlertToastType.CAMERA_MOVEMENT_PORTAL]:
    'assets/images/icons/svg/motion-detection-disabled.svg',
  [AlertToastType.PERSON_DETECTION_v2]:
    'assets/images/icons/svg/motion-detection-disabled.svg',
  [AlertToastType.CAMERA_PANIC]: 'assets/images/icons/svg/geo-alert.svg',
  [AlertToastType.CAMERA_DOWNLOAD]:
    'assets/images/icons/svg/video-download.svg',
  [AlertToastType.PLATE]:
    'assets/images/icons/svg/auto-ocr-detection-disabled.svg',
  [AlertToastType.VEHICLE_MODEL]:
    'assets/images/icons/svg/auto-ocr-detection-disabled.svg',
  [AlertToastType.FACIAL]:
    'assets/images/icons/svg/facial_recognition_disabled.svg',
  [AlertToastType.FACIAL_EMBEDDED]:
    'assets/images/icons/svg/facial_recognition_disabled.svg',

  [AlertToastType.FACIAL_IN_GROUP]:
    'assets/images/icons/svg/facial_recognition_disabled.svg',
  [AlertToastType.FACIAL_IN_GROUP_EMBEDDED]:
    'assets/images/icons/svg/facial_recgnition_disabled.svg',
  [AlertToastType.FACIAL_CAMERA_GROUP]:
    'assets/images/icons/svg/facial_recognition_disabled.svg',
  [AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED]:
    'assets/images/icons/svg/facial_recognition_disabled.svg',
  [AlertToastType.FACIAL_UNIDENTIFIED]:
    'assets/images/icons/svg/facial_recognition_disabled.svg',
  [AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED]:
    'assets/images/icons/svg/facial_recognition_disabled.svg',
  [AlertToastType.AGGLOMERATION_DETECTION]:
    'assets/images/icons/svg/crowd_detection_disabled.svg',
  [AlertToastType.FALL_DETECTION]:
    'assets/images/icons/svg/fall_detection_disabled.svg',
  [AlertToastType.PERSONAL_PANIC]: 'assets/images/icons/svg/alert_triangle.svg',
  [AlertToastType.ADVANCED_SEARCH_FINISHED]:
    'assets/images/icons/svg/alert_triangle.svg',
};

export const TITLE_HEADER_MAP: Partial<Record<AlertToastType, string>> = {
  [AlertToastType.CAMERA_MOVEMENT]: 'Movimento detectado!',
  [AlertToastType.CAMERA_MOVEMENT_PORTAL]: 'Movimento detectado!',
  [AlertToastType.PERSON_DETECTION_v2]: 'Pessoa detectada!',
  [AlertToastType.CAMERA_PANIC]: 'Alerta!!',
  [AlertToastType.CAMERA_DOWNLOAD]: 'Seu arquivo está pronto para download.',
  [AlertToastType.FACIAL]: 'Reconhecimento Facial',
  [AlertToastType.FACIAL_EMBEDDED]: 'Reconhecimento Facial',
  [AlertToastType.FACIAL_IN_GROUP]: 'Reconhecimento Facial - Grupo',
  [AlertToastType.FACIAL_IN_GROUP_EMBEDDED]: 'Reconhecimento Facial - Grupo',
  [AlertToastType.FACIAL_CAMERA_GROUP]:
    'Reconhecimento Facial - Pessoa de Interesse',
  [AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED]:
    'Reconhecimento Facial - Pessoa de Interesse',
  [AlertToastType.FACIAL_UNIDENTIFIED]: 'Facial Não Identificado',
  [AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED]: 'Facial Não Identificado',
  [AlertToastType.PLATE]: 'Placa Detectada!',
  [AlertToastType.VEHICLE_MODEL]: 'Modelo Detectado!',
  [AlertToastType.AGGLOMERATION_DETECTION]: 'Aglomeração detectada!',
  [AlertToastType.FALL_DETECTION]: 'Queda detectada!',
  [AlertToastType.PERSONAL_PANIC]: 'Alerta de Pânico!!',
  [AlertToastType.ADVANCED_SEARCH_FINISHED]: 'Busca Avançada finalizada!',
};

// ─── Tipos utilitários para cores de botão ────────────────────────────────────

export const BUTTON_BG_PURPLE_TYPES: AlertToastType[] = [
  AlertToastType.PLATE,
  AlertToastType.PERSON_DETECTION,
  AlertToastType.CAMERA_MOVEMENT,
  AlertToastType.CAMERA_MOVEMENT_PORTAL,
  AlertToastType.PERSON_DETECTION_v2,
  AlertToastType.motionAlert,
  AlertToastType.CAMERA_DOWNLOAD,
  AlertToastType.FACIAL,
  AlertToastType.FACIAL_EMBEDDED,
  AlertToastType.FACIAL_IN_GROUP,
  AlertToastType.FACIAL_IN_GROUP_EMBEDDED,
  AlertToastType.FACIAL_CAMERA_GROUP,
  AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED,
  AlertToastType.FACIAL_UNIDENTIFIED,
  AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED,
  AlertToastType.AGGLOMERATION_DETECTION,
  AlertToastType.FALL_DETECTION,
  AlertToastType.ADVANCED_SEARCH_FINISHED,
];

export const TITLE_DARK_COLOR_TYPES: AlertToastType[] = [
  AlertToastType.PERSON_DETECTION,
  AlertToastType.CAMERA_MOVEMENT,
  AlertToastType.CAMERA_MOVEMENT_PORTAL,
  AlertToastType.PERSON_DETECTION_v2,
  AlertToastType.motionAlert,
  AlertToastType.FACIAL,
  AlertToastType.FACIAL_EMBEDDED,
  AlertToastType.FACIAL_IN_GROUP,
  AlertToastType.FACIAL_IN_GROUP_EMBEDDED,
  AlertToastType.FACIAL_CAMERA_GROUP,
  AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED,
  AlertToastType.FACIAL_UNIDENTIFIED,
  AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED,
  AlertToastType.ADVANCED_SEARCH_FINISHED,
];

// ─── Tipos de notificação válidos para exibição ───────────────────────────────

export const VALID_NOTIFICATION_TYPES: AlertToastType[] = [
  AlertToastType.CAMERA_MOVEMENT,
  AlertToastType.CAMERA_MOVEMENT_PORTAL,
  AlertToastType.PERSON_DETECTION_v2,
  AlertToastType.CAMERA_PANIC,
  AlertToastType.CAMERA_DOWNLOAD,
  AlertToastType.CAMERA_STATUS,
  AlertToastType.PLATE,
  AlertToastType.VEHICLE_MODEL,
  AlertToastType.FACIAL,
  AlertToastType.FACIAL_EMBEDDED,
  AlertToastType.FACIAL_IN_GROUP,
  AlertToastType.FACIAL_IN_GROUP_EMBEDDED,
  AlertToastType.FACIAL_CAMERA_GROUP,
  AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED,
  AlertToastType.FACIAL_UNIDENTIFIED,
  AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED,
  AlertToastType.AGGLOMERATION_DETECTION,
  AlertToastType.FALL_DETECTION,
  AlertToastType.PERSONAL_PANIC,
  AlertToastType.ADVANCED_SEARCH_FINISHED,
];

export const IMMEDIATE_DATE_TYPES: AlertToastType[] = [
  AlertToastType.CAMERA_STATUS,
  AlertToastType.CAMERA_PANIC,
  AlertToastType.CAMERA_DOWNLOAD,
];

export const TOAST_TITLE_VALID_TYPES: AlertToastType[] = [
  AlertToastType.CAMERA_MOVEMENT,
  AlertToastType.CAMERA_MOVEMENT_PORTAL,
  AlertToastType.PERSON_DETECTION_v2,
  AlertToastType.CAMERA_PANIC,
  AlertToastType.CAMERA_STATUS,
  AlertToastType.PLATE,
  AlertToastType.VEHICLE_MODEL,
  AlertToastType.FACIAL,
  AlertToastType.FACIAL_EMBEDDED,
  AlertToastType.FACIAL_IN_GROUP,
  AlertToastType.FACIAL_IN_GROUP_EMBEDDED,
  AlertToastType.FACIAL_CAMERA_GROUP,
  AlertToastType.FACIAL_CAMERA_GROUP_EMBEDDED,
  AlertToastType.FACIAL_UNIDENTIFIED,
  AlertToastType.FACIAL_UNIDENTIFIED_EMBEDDED,
  AlertToastType.PERSONAL_PANIC,
  AlertToastType.AGGLOMERATION_DETECTION,
  AlertToastType.FALL_DETECTION,
  AlertToastType.ADVANCED_SEARCH_FINISHED,
];
